import type { CompanyFormat } from "@majitap/ui";
import { useSuspenseQuery } from "@tanstack/react-query";
import { meQuery } from "./session";

/** The active company's currency and time zone: how every amount and time on a page reads. */
export function useCompanyFormat(): CompanyFormat {
  const { data: me } = useSuspenseQuery(meQuery);
  return {
    currency: me?.active_company?.currency ?? "KES",
    timezone: me?.active_company?.timezone ?? "Africa/Nairobi",
  };
}
